enum ModalStates {
	INACTIVE = 0,
	ACTIVE = 1
}

export { ModalStates };
